import type {Account} from "../../../types/Account";
import SupplierBookingAdjustModal from './SupplierBookingAdjustModal';
import SupplierDeclineBookingModal from './declineModal/SupplierDeclineBookingModal';
import { modalTypes } from '../SupplierBookingList';

import type { JSX } from "react";

interface ReasonDeclinedType {
  reason: string;
  notes: string;
}

type BookingDialogProps = {
  openModal: String,
  account: Account,
  booking: {id: string, reasonDeclined: string, reasonDeclinedNote: string, orderNumber: string},
  endDate: string,
  handleDatePicker: () => void,
  adjustBookingDates: () => void,
  onSubmitDecline: (reason: ReasonDeclinedType) => void,
  onCancelBooking: (callbackActions: any) => void,
  handleClose: (callbackActions?: any) => void
};

const SupplierBookingApprovalsDialogWrapper: (props: BookingDialogProps) => JSX.Element = (props) => {
  const {openModal, booking, endDate, handleDatePicker, adjustBookingDates, onSubmitDecline, handleClose} = props;

  const determineOpenDialog = (type: string) => openModal === type;

  return (
    <>
        <SupplierBookingAdjustModal
            openModal={determineOpenDialog(modalTypes.adjust)}
            adjustBookingDates={adjustBookingDates}
            handleClose={handleClose}
            endDate={endDate}
            handleDatePicker={handleDatePicker}
        />
        <SupplierDeclineBookingModal
            open={determineOpenDialog(modalTypes.decline)}
            onClose={handleClose}
            onSubmit={onSubmitDecline}
            booking={booking}
        />
    </>
  );
};

export default SupplierBookingApprovalsDialogWrapper;
